<template>
  <a-button
      :title="title"
      :style="color ? { backgroundColor: color, borderColor: color } : undefined"
      class="button loadingButton"
      :type="type"
      @click="onClick"
      :disabled="disabled || loading"
      :loading="loading"
  >
    <a-icon :type="icon" class="icon" v-if="!loading" />
  </a-button>
</template>

<script>
export default {
  name: "IconButton",
  props: ['type', 'color', 'title', 'icon', 'disabled', 'loading'],
  methods: {
    onClick() {
      if (!this.loading && !this.disabled) {
        this.$emit('click');
      }
    }
  }
}
</script>

<style scoped>
.icon {
  color: white;
}
.button {
  width: 30px;
  height: 30px;
  border-radius: 24px;
}

.loadingButton {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
}
</style>